"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcFillHeightPercent = exports.getFrameAspectRatio = void 0;
var Image_1 = require("@CommonFrontend/ContentTokens/Models/Image");
function getFrameAspectRatio(_a) {
    var frame = _a.frame, aspectRatio = _a.aspectRatio, frameAspectRatio = _a.frameAspectRatio;
    if (frameAspectRatio)
        return frameAspectRatio;
    if (frame === Image_1.ImageFrame.Circle)
        return 1;
    return aspectRatio !== null && aspectRatio !== void 0 ? aspectRatio : 1;
}
exports.getFrameAspectRatio = getFrameAspectRatio;
function calcFillHeightPercent(aspectRatio, frameAspectRatio) {
    if (aspectRatio > frameAspectRatio) {
        var fillHeightPercent = (aspectRatio / frameAspectRatio) * 100;
        return "".concat(fillHeightPercent, "%");
    }
    return null;
}
exports.calcFillHeightPercent = calcFillHeightPercent;
